import * as React from 'react';
import { cn } from '@companion-professional/webutils';

// DialogHeader is the header section of the Dialog.  This can contain the <DialogTitle> and <DialogDescription>
// components.
export const DialogHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col space-y-1.5 text-center sm:text-left', className)} {...props} />
);
DialogHeader.displayName = 'DialogHeader';
